import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const CLICK_IMAGE_TYPE: string = 'clickImage';

@injectable()
export class ClickImageItemsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.image-click-component', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(CLICK_IMAGE_TYPE, $element.attr('id'));
      const title: string = $element.attr('data-title') || 'click-image-component';

      const items: { [id: string]: boolean } = {};
      $('.image-click-item', $element).each((itemIndex: number) => {
        const itemId: string = this.sectionProgressUtils.createItemId(id, itemIndex);
        items[itemId] = false;
      });

      interactions = [...interactions, {
        id,
        title,
        type: CLICK_IMAGE_TYPE,
        completed: false,
        items
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === CLICK_IMAGE_TYPE) {
      const clickImageId: string = interaction.id;
      const itemId: string = this.sectionProgressUtils.createItemId(clickImageId, interaction.index);
      completion = this.sectionProgressUtils.setInteractionItemCompleted(
        completion,
        clickImageId,
        CLICK_IMAGE_TYPE,
        itemId
      );
    }

    return completion;
  }
}
